module.exports = __webpack_public_path__ + "img/slider_11.91e3e6e5.jpg";